export const EMPTY_ENUM_VALUE = {value: ''};
